import { Reducer } from 'redux';

import { ActionType } from '../../../store/actionTypes';
import {
  EntityAction,
  ErrorAction,
  Action as PlainAction,
} from '../../../store/types';

export interface EventsState {
  view: {
    items: string[];
    isFetching: boolean;
    error?: string | null;
  };
}

export const initialState: EventsState = {
  view: {
    items: [],
    isFetching: false,
    error: null,
  },
};

type Action =
  | PlainAction<ActionType.FETCH_EVENTS_STARTED>
  | EntityAction<ActionType.FETCH_EVENTS_SUCCEEDED>
  | ErrorAction<ActionType.FETCH_EVENTS_FAILED>;

const eventsReducer: Reducer<EventsState, Action> = (
  state: EventsState = initialState,
  action: Action,
) => {
  switch (action.type) {
    case ActionType.FETCH_EVENTS_STARTED:
      return {
        ...state,
        view: {
          ...state.view,
          isFetching: true,
        },
      };

    case ActionType.FETCH_EVENTS_SUCCEEDED:
      return {
        ...state,
        view: {
          ...state.view,
          isFetching: false,
          items: action.payload.result as string[],
        },
      };

    case ActionType.FETCH_EVENTS_FAILED:
      return {
        ...state,
        view: {
          ...state.view,
          isFetching: false,
          error: action.payload.message,
        },
      };

    default:
      return state;
  }
};

export default eventsReducer;
